module.exports = __webpack_public_path__ + "static/media/aroldo-mostrandoacima-esquerda.b5eb0898.svg";